import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PortfolioCarousel = () => {
  // Using actual ModArch theme images
  const projects = [
    {
      id: 1,
      title: 'Project Echo – Monochrome, modern vibes',
      category: 'Interior',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-c.jpg'
    },
    {
      id: 2,
      title: 'Haven Hill – A peaceful suburban retreat',
      category: 'Residential Project',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-d.jpg'
    },
    {
      id: 3,
      title: 'Villa Solis – Luxury with warmth and sunlight',
      category: 'Residential Project',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-e.jpg'
    },
    {
      id: 4,
      title: 'Casa Luma – Light-filled modern home',
      category: 'Residential Project',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-f.jpg'
    },
    {
      id: 5,
      title: 'The Velvet Room – Luxurious and dramatic',
      category: 'Interior',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-a.jpg'
    },
    {
      id: 6,
      title: 'Terra Layers – Earth-toned, natural interiors',
      category: 'Interior',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/05/modarch-m1-s3-img-b.jpg'
    }
  ];

  return (
    <section className="portfolio-carousel-section">
      <div className="portfolio-carousel-header">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Popular projects
        </motion.h2>
      </div>

      <div className="portfolio-carousel-wrapper">
        <div className="portfolio-carousel-marquee">
          <motion.div 
            className="portfolio-carousel-track"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            {/* Duplicate projects for seamless infinite scroll */}
            {[...projects, ...projects].map((project, index) => (
              <article 
                key={`${project.id}-${index}`}
                className="portfolio-carousel-item"
              >
                <Link to={`/portfolio/${project.id}`} className="portfolio-carousel-link">
                  <div className="portfolio-carousel-image">
                    <img src={project.image} alt={project.title} />
                    <div className="portfolio-carousel-overlay">
                      <span className="view-project">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className="portfolio-carousel-info">
                    <span className="portfolio-carousel-category">{project.category}</span>
                    <h3 className="portfolio-carousel-title">{project.title}</h3>
                  </div>
                </Link>
              </article>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioCarousel;
